// Copyright (c) StrangeBee 2023

import React, { ReactElement } from 'react';
import { Divider } from 'antd';
import FiltersListField from '@Organisms/Filter/FiltersListField/FiltersListField';
import { FilterInputForm } from '@Hooks/useFilters';
import { DescribeFieldOutput } from 'thehive-sdk';

import './FiltersList.scss';

interface FiltersListProps {
    filters: FilterInputForm[];
    setFilters: (callback: (filters: FilterInputForm[]) => FilterInputForm[]) => void;
    describeField?: DescribeFieldOutput;
    vertical?: boolean;
    removeTempFilter: (index: number) => void;
    aggregationWarning?: boolean;
}

const FiltersList = ({
    filters,
    setFilters,
    describeField,
    vertical = false,
    removeTempFilter,
    aggregationWarning = false,
}: FiltersListProps): ReactElement | null => {
    return filters.length ? (
        <div className="filters-list">
            {filters.map((filter, index) => (
                <div key={index}>
                    {vertical && index !== 0 && <Divider />}
                    <FiltersListField
                        removeTempFilter={removeTempFilter}
                        index={index}
                        setFilters={setFilters}
                        describeField={describeField}
                        filter={filter}
                        vertical={vertical}
                        key={`filtersList-${index}`}
                        aggregationWarning={aggregationWarning}
                    />
                </div>
            ))}
        </div>
    ) : null;
};

export default FiltersList;
